import { memo } from "react";
import type { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { OnboardingApplicationStatus as OnboardingApplicationStatusComponent } from "ui/molecules/Status";
import When from "ui/support/When";
import type { OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges } from "../types";

const ToApplicationStatus = ({ row }: GridRenderCellParams<OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges>) => {
    const { changes } = row;

    const toStatus = changes
        ?.status
        ?.filter(Boolean)
        .at(-1);

    return (
        <When
            if={Boolean(toStatus)}
            then={() => (
                <OnboardingApplicationStatusComponent
                    label={toStatus}
                />
            )}
        >
            -
        </When>
    );
};

export default memo(ToApplicationStatus);
